"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReferenceCount = void 0;
const context_1 = require("../context");
const react_1 = require("react");
const reference_count_1 = require("./reference_count");
const useReferenceCount = (datasheetId, viewId) => {
    const context = (0, react_1.useContext)(context_1.WidgetContext);
    const preDatasheetId = (0, react_1.useRef)();
    const preViewId = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        if (!datasheetId || !viewId) {
            return;
        }
        const pDatasheetId = preDatasheetId.current;
        const pViewId = preViewId.current;
        // If the datasheetId or viewId is changed, the previous reference count is removed.
        if (datasheetId !== pDatasheetId || viewId !== pViewId) {
            reference_count_1.widgetReferenceCount.remove(datasheetId, viewId, context.id);
            preDatasheetId.current = datasheetId;
            preViewId.current = viewId;
        }
        reference_count_1.widgetReferenceCount.add(datasheetId, viewId, context.id);
        return () => reference_count_1.widgetReferenceCount.remove(datasheetId, viewId, context.id);
    }, [datasheetId, viewId, context.id]);
};
exports.useReferenceCount = useReferenceCount;
